import React from "react";

function MonthView({
  calendarDays,
  appointments,
  currentDate,
  setSelectedSlot,
  setShowAppointmentPanel,
}) {
  const getAppointmentsForDay = (dayObj) => {
    const fullDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      dayObj.day
    );

    return appointments?.filter((app) => {
      const appDate = new Date(app.date);
      return (
        appDate.getDate() === fullDate.getDate() &&
        appDate.getMonth() === fullDate.getMonth() &&
        appDate.getFullYear() === fullDate.getFullYear()
      );
    });
  };

  const addMinutesToTime = (timeStr, durationStr) => {
    const [hours, minutes] = timeStr.split(":").map(Number);
    const durationMinutes = parseInt(durationStr); // e.g., "34 minutes" -> 34
    const start = new Date();
    start.setHours(hours, minutes);
    const end = new Date(start.getTime() + durationMinutes * 60000);

    return `${String(end.getHours()).padStart(2, "0")}:${String(
      end.getMinutes()
    ).padStart(2, "0")}`;
  };

  return (
    <div className="month-view_CalendarView">
      <div className="month-view-header_CalendarView">
        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
          <div
            key={day}
            style={{
              padding: "10px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {day}
          </div>
        ))}
      </div>

      <div className="month-view-grid_CalendarView">
        {calendarDays.map((dayObj, index) => {
          const appointmentsForDay = getAppointmentsForDay(dayObj);

          // full date object for selected day
          const fullDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            dayObj.day
          );

          return (
            <div
              key={index}
              className={`month-view-day_CalendarView ${
                dayObj.isCurrentMonth ? "current-month" : "other-month"
              }`}
              style={{
                color: dayObj.isCurrentMonth ? "#333" : "#999",
                backgroundColor: dayObj.isCurrentMonth ? "#ffffff" : "#f8f9fa",
                padding: "5px",
                cursor: "pointer", 
              }}
         onClick={() => {
  console.log(fullDate, "-=-=-=full=-=-=");
  setSelectedSlot({
    date: fullDate,
    slot: {
      value: 0,        // default midnight
      display: "12:00 AM",
    },
    startTime: "00:00", // default start time
  });
  setShowAppointmentPanel(true);
}}


            >
              <div style={{ fontWeight: "bold" }}>{dayObj.day}</div>

              <div style={{ marginTop: "auto" }}>
                {appointmentsForDay.map((app, idx) => {
                  const startTime = app.startTime || "00:00";
                  const duration = parseInt(app.Duration?.split(" ")[0] || "0");
                  const endTime = addMinutesToTime(startTime, duration);

                  return (
                    <div
                      key={idx}
                      style={{
                        fontSize: "10px",
                        marginTop: "2px",
                        background: "#e0f7fa",
                        padding: "2px 3px",
                        borderRadius: "4px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        textAlign: "left",
                      }}
                    >
                      <div>
                        <strong>
                          {startTime} - {endTime}
                        </strong>
                      </div>
                      <div>
                        Client: {app?.patientRequestId?.firstName}{" "}
                        {app?.patientRequestId?.lastName}
                      </div>
                      <div>
                        Provider: {app?.doctorRequestId?.firstName}{" "}
                        {app?.doctorRequestId?.lastName}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MonthView;
